const { InnerBlocks } = wp.blockEditor;

import Inspector from './inspector';

export default ({ attributes, setAttributes }) => {
  const {
    image,
    image2,
    contentPos,
    imgPosVertical,
    margin,
    background,
    imageOption,
    maxWidth,
  } = attributes;

  const ALLOWED_BLOCKS = [
    'base/heading-sumicity',
    'base/paragraph-sumicity',
    'base/button-sumicity',
  ];

  return (
    <>
      <Inspector attributes={attributes} setAttributes={setAttributes} />

      <section className={`Hero ${margin} ${background} ${imageOption}`}>
        <div className={`Hero__wrapper Container Hero__wrapper-${contentPos}`}>
          <div className={`Hero--content ${maxWidth}`}>
            <InnerBlocks allowedBlocks={ALLOWED_BLOCKS} />
          </div>

          <div
            className={`Hero--imageWrapper Hero--imageWrapper-${imgPosVertical}  Hero--imageWrapper-${contentPos}`}
          >
            <img className="Hero__content-image" src={image.src} />
            {imageOption == 'twoImages' && (
              <img className="Hero__content-image" src={image2.src} />
            )}
          </div>
        </div>
      </section>
    </>
  );
};
